var guideFeaturedArticle = document.getElementById("guide-featured-article"),
  guideBannerSection = document.getElementById("guideBannerSection"),
  guideBrandSection = document.querySelector('.brands'),
  ctaSectionNudge = document.querySelector('.guide-signup-nudge'),
  bannerHeight = 0;

//for guide Banner section exp
if (guideBannerSection) {
  var guideBrandSectionHeight = guideBrandSection ? guideBrandSection.offsetHeight : 0;
  bannerHeight = guideBannerSection.offsetHeight + guideBrandSectionHeight;
}

if (guideFeaturedArticle) {
  var rect = document
      .querySelector(".raw-text-pad-top")
      .getBoundingClientRect();

  if (guideFeaturedArticle.classList.contains("guide-featured-article--show")) {
    //set position and width
    guideFeaturedArticle.style.top = window.innerHeight + bannerHeight / 2 + "px";
    guideFeaturedArticle.style.width =
      (window.innerWidth - rect.width) / 2 -
      (window.innerWidth > 1440 ? 60 : 40) +
      "px";
    guideFeaturedArticle.style.right =
      rect.left -
      guideFeaturedArticle.offsetWidth -
      (window.innerWidth > 1440 ? 30 : 20) +
      "px";
  }
  
  //scroll event
  window.addEventListener(
    "scroll",
    function() {
      if (window.innerWidth >= 1280 && guideFeaturedArticle.classList.contains("guide-featured-article--show")) {

        if (guideFeaturedArticle.classList.contains("vwo-hide")) {
          guideFeaturedArticle.classList.remove("vwo-hide");
        }

        //set right position
        rect = document
          .querySelector(".raw-text-pad-top")
          .getBoundingClientRect();

        //for guide Banner section exp
        if (guideBannerSection) {
          guideBrandSectionHeight = guideBrandSection ? guideBrandSection.offsetHeight : 0;
          bannerHeight = guideBannerSection.offsetHeight + guideBrandSectionHeight;
        }

        // check cta section nudge height for experiment
        var ctaSectionNudgeHeight = ctaSectionNudge ? ctaSectionNudge.offsetHeight : 0,
          ctaSectionBufferHeight = 0;

        if (ctaSectionNudgeHeight && window.innerHeight < 700) {
          ctaSectionBufferHeight = 80; // buffer height for screen height less than 700px
        }

        guideFeaturedArticle.style.right =
          rect.left -
          guideFeaturedArticle.offsetWidth -
          (window.innerWidth > 1440 ? 30 : 20) +
          "px";

        // set default absolute position
        if (
          window.pageYOffset <
          window.innerHeight / 2 + bannerHeight / 2 + guideFeaturedArticle.offsetHeight / 2
        ) {
          guideFeaturedArticle.style.top = window.innerHeight + ctaSectionBufferHeight + bannerHeight / 2 - ctaSectionNudgeHeight / 2 + "px";
          guideFeaturedArticle.classList.remove(
            "guide-featured-article--fixed"
          );
        } else if (window.pageYOffset > rect.height + bannerHeight - window.innerHeight) {
          //bottom absolute position
          guideFeaturedArticle.style.top =
            rect.height + bannerHeight -
            window.innerHeight / 2 -
            guideFeaturedArticle.offsetHeight / 2 -
            ctaSectionNudgeHeight / 2 +
            ctaSectionBufferHeight +
            "px";
          guideFeaturedArticle.classList.remove(
            "guide-featured-article--fixed"
          );
        } else {
          //set fixed position
          guideFeaturedArticle.classList.add("guide-featured-article--fixed");
            guideFeaturedArticle.style.top =
              window.innerHeight / 2 -
              guideFeaturedArticle.offsetHeight / 2 -
              ctaSectionNudgeHeight / 2 +
              ctaSectionBufferHeight +
              "px";
        }
      }
    },
    false
  );

  //resize event
  window.addEventListener(
    "resize",
    function() {
      if (window.innerWidth >= 1280 && guideFeaturedArticle.classList.contains("guide-featured-article--show")) {
        //set width and right position
        rect = document
          .querySelector(".raw-text-pad-top")
          .getBoundingClientRect();
        guideFeaturedArticle.style.width =
          (window.innerWidth - rect.width) / 2 -
          (window.innerWidth > 1640 ? 60 : 40) +
          "px";
        guideFeaturedArticle.style.right =
          rect.left -
          guideFeaturedArticle.offsetWidth -
          (window.innerWidth > 1640 ? 30 : 20) +
          "px";
      }
    },
    false
  );
}
